import React from "react";
import localizationApi from "./Localizations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import statusPageData from "./SpData";
import ubisoft_logo from "./images/ubisoftlogo.png";
import {localesWithNoSocialLinks} from "./utils";

interface Props {
    locale: string;
    sp_identifier: string;
    onLocaleChange: (locale: string) => void;
}
const FooterComp: React.FC<Props> = (props) => {
    let data = statusPageData[props.sp_identifier];
    const isNcsa = props.locale === "en-US" || props.locale === "fr-CA" || props.locale === "en-CA" || props.locale === "es-MX" || props.locale === "pt-BR";
    let region = isNcsa ? "ncsa" : "emea";

    return (
        <footer className="bg-dark">
            <div className="container py-4">
                <div className="d-flex flex-row justify-content-between py-4">
                    <select className="p-2" onChange={(e) => props.onLocaleChange(e.target.value)} value={props.locale}>
                        {Object.keys(localizationApi.supportedLocales).filter(l => data.supportedLocales.length === 0 || data.supportedLocales.find(i => i === l) !== undefined).map(k =>
                            <option key={k} value={k}>{localizationApi.supportedLocales[k]}</option>
                        )}
                    </select>
                    {!localesWithNoSocialLinks.includes(props.locale) &&
                        <ul className="nav">
                            {(data.footer[region].footerSocial[props.locale] ?? data.footer[region].footerSocial["default"])?.map((footerSocial, i) => {
                                return <li className="nav-item" key={i}><a href={footerSocial.link} title={footerSocial.title} className="nav-link"><FontAwesomeIcon icon={footerSocial.icon} color="#fff" /></a></li>;
                            })}
                        </ul>
                    }
                </div>

                {(data.footer[region].footerImages[props.locale] ?? data.footer[region].footerImages["default"])?.map((footerImgGroup, i) => {
                    return <div className="d-flex flex-wrap flex-row align-items-center justify-content-center py-2" key={i}>
                        {data.footer[region].showLogo ?
                            <img src={ubisoft_logo} alt="Ubisoft logo" /> : null}
                        {footerImgGroup.map((footerImg, j) => {
                            return <a className="mx-4" key={j} target="_blank" rel="noopener noreferrer" href={footerImg.link}>
                                <img src={footerImg.img} alt={footerImg.alt} style={{ maxHeight: "120px" }} />
                            </a>;
                        })}
                    </div>
                })}

                <div className="d-flex flex-column small">
                    <p className="copy text-light text-center small">{(data.footer[region].footerCopyTxt[props.locale] ?? data.footer[region].footerCopyTxt["default"])}</p>
                    <div className="legal d-flex flex-row justify-content-center">

                        {(data.footer[region].footerLegalLinks[props.locale] ?? data.footer[region].footerLegalLinks["default"]).map((footerLegalLink, i) => {
                            return <a target="_blank" rel="noopener noreferrer" className="mx-2 text-light text-center small text-uppercase" key={i} href={footerLegalLink.link}>
                                {footerLegalLink.text}
                            </a>;
                        })}
                    </div>
                </div>

            </div>
        </footer>
    );
};

export default FooterComp;
